// Main TypeScript Entry Point

// Import components
import { Navigation } from './components/navigation';
import { SwiperGallery } from './components/swiper-gallery';
import './components/example';

// Initialize application
document.addEventListener('DOMContentLoaded', () => {
  console.log('Application initialized!');
  
  // Initialize navigation
  new Navigation();
  
  // Initialize swiper galleries
  new SwiperGallery();
});
